var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`section-title ${_vm.color} ${_vm.lineColor}`},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"title-text",attrs:{"slot":"primary"},slot:"primary"},[_vm._t("primary")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }